<template>
  <div class="card-container" :class="cardType" :ref="inModal || inUsedModal || inDetail ? cardContainerRef : null" @scroll="onScrollCard">
    <div class="card-content" :ref="inModal || inUsedModal || inDetail ? cardContentRef : null" >
      <div v-if="!inFreePassList" class="card-header">
        <div class="left">
          <div class="card-type" :class="cardType">
            {{ categoryName }}
          </div>
          <div class="expire-at" :class="isCloseExpireAt && 'warning'">
            <div>
              <div>[有効期限]</div>
              <div>{{ expireAtString }}</div>
            </div>
          </div>
        </div>
        <div class="right">
          <img
            v-if="isCloseExpireAt"
            :class="inModal || inUsedModal ? 'in-modal' : 'in-list'"
            :src="require('@/assets/img/coupon-with-cart/close-expire-at-coupon-alert-icon.svg')"
            alt=""
          />
        </div>
      </div>
      <div class="thumbnail-container">
        <img :src="couponImageURL" alt="" @load="imageLoaded" @error="imageLoaded"/>
      </div>
      <div class="notes-container" v-if="inModal || inUsedModal || inDetail">
        <button type="button" @click="showUsageDialog">
          利用条件を確認する
          <img
            :src="require('@/assets/img/coupon-with-cart/coupon-notes-arrow-icon.svg')"
            alt=""
          />
        </button>
        <p class="notes" :class="isUsing && 'using'" v-html="notes" />
      </div>
      <div v-if="inFreePassList" class="expire-at" :class="isCloseExpireAt && 'warning'">
        <div>
          <img
            v-if="isCloseExpireAt && (!inModal || !inUsedModal)"
            :src="require('@/assets/img/coupon-with-cart/close-expire-at-coupon-alert-icon.svg')"
            alt=""
          />
          <span>[有効期限]</span>
          <span>{{ expireAtString }}</span>
        </div>
      </div>
      <template v-if="inDetail && detailButtonLabel">
        <div class="button-container in-modal">
          <button
            type="button"
            :class="[cardType, 'detail']"
            :disabled="disableDetailButton"
            @click="tapDetailButton"
          >
            {{ detailButtonLabel }}
            <img
              v-if="!disableDetailButton"
              :src="require('@/assets/img/coupon-with-cart/card-right-arrow-icon.svg')"
              alt=""
            />
          </button>
        </div>
      </template>
      <template v-else>
        <div class="button-container" :class="[inModal || inUsedModal || inDetail ? 'in-modal' : 'in-list', needsButtonContainerShadow && 'shadow']">
          <template v-if="coupon.data.gift_url">
            <button
              type="button"
              @click="openExternalUrl(coupon.data.gift_url)"
            >
              このギフトをみる
            </button>
          </template>
          <template v-else-if="showDisabledButton">
            <button
              type="button"
              disabled
            >
              {{ disabledButtonLabel }}
            </button>
          </template>
          <template v-else>
            <coupon-with-cart-card-button
              key="eatin"
              :coupon="coupon"
              :select-type="selectTypeEatIn"
              :visible="canShowEatInButton"
              :disabled="disabledEatInButton"
              :in-modal="inModal || inUsedModal"
              :card-type="cardType"
              :is-selected="isSelected"
              :is-using="isUsing"
              @tap-coupon-use="(args) => tapCouponUse(args)"
              @tap-disabled-coupon-use="tapDisabledCouponUse"
            />
            <coupon-with-cart-card-button
              key="gift"
              :coupon="coupon"
              :select-type="selectTypeGift"
              :visible="canShowGiftButton"
              :disabled="disabledGiftButton"
              :in-modal="inModal || inUsedModal"
              :card-type="cardType"
              :is-selected="isSelected"
              :is-using="isUsing"
              @tap-coupon-use="(args) => tapCouponUse(args)"
              @tap-disabled-coupon-use="tapDisabledCouponUse"
            />
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { calcIsCloseExpireAt, COUPON_SELECT_TYPE, SCREEN_TYPE } from '@/store/couponWithCart'
import moment from 'moment'
import CouponWithCartCardButton from '@/views/CouponWithCart/CardButton.vue'
import '@/styles/color.css'

export default {
  name: 'CouponWithCartCard',
  components: { CouponWithCartCardButton },
  props: {
    coupon: { type: Object, required: true },
    index: { type: Number, required: true },
    displayFrom: { type: String, required: true },
    detailButtonLabel: { type: String || null, default: null }
  },
  data() {
    return {
      selectTypeEatIn: COUPON_SELECT_TYPE.eatIn,
      // selectTypeJoynet: COUPON_SELECT_TYPE.joynet,
      selectTypeGift: COUPON_SELECT_TYPE.gift,
      categoryNames: ['何度でもご利用可能', '期間限定', '特典', 'あなただけ'],
      cardTypes: {
        infinite: 'infinite',
        gift: 'gift',
        freePassModal: 'free-pass-modal',
        freePassList: 'free-pass-list',
        lounge: 'lounge',
        timeLimited: 'time-limited',
        prize: 'prize',
        onlyForYou: 'only-for-you'
      },
      needsButtonContainerShadow: false
    }
  },
  computed: {
    ...mapGetters({
      selectedType: 'CouponWithCart/selectedType',
      selectedCoupons: 'CouponWithCart/selectedCoupons'
    }),
    canShowEatInButton() {
      if (this.inModal || this.isSelected) {
        return this.selectedType === COUPON_SELECT_TYPE.eatIn
      }
      return (this.coupon.data.not_eat_in === '0' && !this.coupon.data.last_history_channel) ||
        (this.coupon.data.not_eat_in === '0' &&
          (this.coupon.data.last_history_channel === '0' || this.coupon.data.last_history_channel === '2'))
    },
    disabledEatInButton() {
      return !(this.selectedType === COUPON_SELECT_TYPE.notYet || this.selectedType === COUPON_SELECT_TYPE.eatIn)
    },
    canShowGiftButton() {
      return (this.selectedType === COUPON_SELECT_TYPE.gift || this.cardType === this.cardTypes.gift) &&
        !this.coupon.data.last_history
    },
    disabledGiftButton() {
      const selectedCoupon = this.selectedCoupons.find((c) => {
        return (c.data.coupon_id && c.data.coupon_id === this.coupon.data.coupon_id) ||
          (c.data.prize_id && c.data.prize_id === this.coupon.data.prize_id)
      })
      return !(this.selectedType === COUPON_SELECT_TYPE.notYet || this.selectedType === COUPON_SELECT_TYPE.gift) ||
        this.cardType !== this.cardTypes.gift ||
        (this.selectedCoupons.length > 0 && !selectedCoupon)
    },
    disableDetailButton() {
      return this.coupon.data.status === '3'
    },
    categoryName() {
      if (this.coupon.data.type === '1') {
        return 'デジタルギフト'
      } else {
        if (this.coupon.data.purpose !== '0') {
          return this.categoryNames[3]
        }
        return this.categoryNames[this.coupon.data.coupon_category]
      }
    },
    cardType() {
      let type = this.cardTypes.infinite
      if (this.coupon.data.type === '1') {
        type = this.cardTypes.gift
      } else if (this.coupon.data.prize_type !== '0') {
        const baseType = (this.inModal || this.inUsedModal || this.inDetail) ? this.cardTypes.freePassModal : this.cardTypes.freePassList
        type = `${baseType}-${this.coupon.data.prize_type}`
      } else {
        if (this.coupon.data.target_user_type !== '0') {
          type = this.cardTypes.lounge
        } else {
          if (this.coupon.data.coupon_category === '1') {
            type = this.cardTypes.timeLimited
          } else if (this.coupon.data.coupon_category === '3' || this.coupon.data.purpose !== '0') {
            type = this.cardTypes.onlyForYou
          } else if (this.coupon.data.coupon_category === '2') {
            type = this.cardTypes.prize
          }
        }
      }
      return type
    },
    expireAtString() {
      let expireAt = this.coupon.data.expire_at
      if (this.coupon.data.type === '1') {
        expireAt = this.coupon.data.gift_expire
      }

      if (expireAt) {
        if (expireAt === '9999-12-31 23:59:59') {
          return '無期限'
        }
        return moment(expireAt).format('YYYY/MM/DD HH:mm')
      } else {
        return `ー`
      }
    },
    notes() {
      return this.cardType.startsWith(this.cardTypes.freePassModal) ?
        `<div style="text-align: center; font-size: 16px; font-weight: bold; color: #e03535">フリーパスのご利用期限は<br />獲得後${this.coupon.data.expire_days}日間です。</div>` :
        this.coupon.data.message
    },
    cardContainerRef() {
      return `cardContainer-${this.index}`
    },
    cardContentRef() {
      return `cardContent-${this.index}`
    },
    isCloseExpireAt() {
      return calcIsCloseExpireAt(this.coupon.data.expire_at)
    },
    couponImageURL() {
      if (!this.coupon.data.thumb_url && !this.coupon.data.freepass_detail_image_url) {
        return ''
      }
      return this.cardType.startsWith(this.cardTypes.freePassModal) ? this.coupon.data.freepass_detail_image_url : this.coupon.data.thumb_url
    },
    inFreePassList() {
      return this.cardType.startsWith(this.cardTypes.freePassList)
    },
    showDisabledButton() {
      return this.coupon.data.is_off || this.coupon.data.status === '0' || this.coupon.data.status === '3'
    },
    disabledButtonLabel() {
      let label = '利用できないクーポンです'
      if (this.coupon.data.is_off) {
        label = 'クーポン利用可能期間外です'
      } else if (this.coupon.data.status === '0') {
        label = 'ご利用可能時間が終了しました'
      } else if (this.coupon.data.status === '3') {
        label = 'スタンプをためて特典をもらおう'
      }
      return label
    },
    isSelected() {
      const selectedCoupon = this.selectedCoupons.find((c) => {
        return (c.data.coupon_id && c.data.coupon_id === this.coupon.data.coupon_id) ||
          (c.data.prize_id && c.data.prize_id === this.coupon.data.prize_id)
      })
      return !!selectedCoupon
    },
    isUsing() {
      return moment(this.coupon.data.last_history).isValid()
    },
    inModal() {
      return this.displayFrom === SCREEN_TYPE.modal
    },
    inUsedModal() {
      return this.displayFrom === SCREEN_TYPE.usedModal
    },
    inDetail() {
      return this.displayFrom === SCREEN_TYPE.detail
    }
  },
  methods: {
    ...mapActions('CouponWithCart', [
      'addToSelectedCoupon',
      'removeFromSelectedCoupon',
      'setSelectedType'
    ]),
    tapCouponUse({ selectType, coupon }) {
      this.setSelectedType(selectType)
      if (this.inModal) {
        this.modifyCart(coupon)
      } else {
        this.$emit('show-modal')
      }
    },
    tapDisabledCouponUse() {
      this.$emit('show-needs-clear-coupon-dialog')
    },
    modifyCart(coupon) {
      if (this.isSelected) {
        this.removeFromSelectedCoupon(coupon)
      } else {
        this.addToSelectedCoupon(coupon)
      }
    },
    showUsageDialog() {
      const content = this.inDetail ? this.coupon.data.article : this.coupon.data.terms
      this.$emit('show-usage-dialog', { content, isHtmlDisplay: this.coupon.is_html_display })
    },
    imageLoaded() {
      if (this.$refs[this.cardContainerRef]) {
        const rect = this.$refs[this.cardContainerRef].getBoundingClientRect()
        this.$emit('card-loaded', { top: rect.top, bottom: rect.bottom })

        if (this.$refs[this.cardContentRef]) {
          this.needsButtonContainerShadow = this.$refs[this.cardContentRef].clientHeight > this.$refs[this.cardContainerRef].clientHeight
        }
      }
    },
    openExternalUrl(url) {
      this.$emit('open-external-url', url)
    },
    tapDetailButton() {
      this.$emit('tap-detail-button')
    },
    onScrollCard(e) {
      this.needsButtonContainerShadow = !(e.target.scrollTop > 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.card-container {
  width: 100%;
  // クーポンカード内で inner scroll させる場合は下記を有効化
  // max-height: 68%;
  // overflow: scroll;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
  margin-bottom: 10px;
  overflow: hidden;
  position: relative;

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 38px;
    background: #eeeeee;
    position: relative;

    .left {
      display: flex;
      height: 100%;

      .card-type {
        width: 130px;
        height: 100%;
        background: #cc0000;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 11px;
        font-weight: bold;
        color: #ffffff;

        &.infinite {
          background: #efb80c;
        }

        &.lounge {
          background: linear-gradient(40deg, #c0a417 0%, #c0a417 39%, #e2c743 51%, #c0a417 64%, #c0a417 100%);
          &::before {
            content: url('~@/assets/img/coupon-with-cart/card-type-lounge-icon.svg');
            margin-right: 4px;
          }
        }

        &.prize {
          &::before {
            content: url('~@/assets/img/coupon-with-cart/card-type-prize-icon.svg');
            margin-right: 4px;
          }
        }

        &.gift {
          background: #e3587f;
        }
      }

      .expire-at {
        font-size: 10px;
        font-weight: bold;
        color: #666666;
        display: flex;
        align-items: center;
        padding-left: 10px;
        text-align: left;

        &.warning {
          color: #bc401e;
        }
      }
    }

    .right {
      height: 100%;
      display: flex;
      align-items: center;
      padding-right: 8px;

      button {
        display: block;
        height: 100%;
        width: 38px;

        img {
          width: 10px;
          height: 10px;
        }
      }

      img {
        width: 20px;
        height: 20px;

        &.in-modal {
          margin-right: 0;
        }
      }

    }
  }

  .thumbnail-container {
    img {
      width: 100%;
      vertical-align: bottom;
    }
  }

  .notes-container {
    font-size: 11px;
    font-weight: bold;
    color: #333333;
    padding: 15px 15px 5px;

    .notes {
      margin-top: 15px;

      &.using {
        opacity: 0;
      }
    }

    button {
      width: 100%;
      background: var(--background-color);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-weight: bold;
      color: #66160E;
      padding: 10px;

      img {
        margin-left: 6px;
      }
    }
  }

  .button-container {
    position: sticky;
    bottom: 0;
    display: flex;
    padding: 10px;
    height: 60px;
    background: #ffffff;
    border-radius: 0 0 8px 8px;
    transition: box-shadow 0.25s;

    & > * + * {
      margin-left: 10px;
    }

    &.in-modal {
      height: 80px;

      &.using {
        &.disabled {
          opacity: 1.0;
        }
      }
    }

    &.in-list {
      &::before {
        content: "";
        background-image: linear-gradient(to right, #cccccc, #cccccc 2px, transparent 3px, transparent 8px);
        background-size: 7px 2px;
        background-repeat: repeat-x;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        pointer-events: none;
      }

      button {
        font-size: unquote("min(3.5vw, 14px)");
      }
    }

    &.shadow {
      box-shadow: 0px -2px 15px 0px rgba(0, 0, 0, 0.35);
    }

    ::v-deep button {
      background: var(--dark-accent-color);
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      flex: auto;
      font-weight: bold;
      border-radius: 6px;
      border-top: 4px solid #98441f;
      border-left: 4px solid #98441f;
      border-bottom: 4px solid #311300;
      border-right: 4px solid #311300;
      padding: 0 10px;

      & > * + * {
        margin-left: 10px;
      }

      .badge {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: unquote("min(3vw, 12px)");
        color: #66160E;
        background: #ffffff;
        height: 28px;
        padding: 0 12px;
        border-radius: 20px;
        flex-shrink: 0;

        &.close-expire-at {
          color: #e03535;
        }
      }

      .label {
        flex-shrink: 0;
        .small-caption {
          font-size: unquote("min(3vw, 11px)");
        }
      }

      &.selected {
        border-top: none!important;
        border-right: none!important;
        border-bottom: none!important;
        border-left: none!important;
      }

      &.in-modal, &.detail {
        font-size: unquote("min(4vw, 16px)");
        background: var(--dark-accent-color);
        border-top: 5px solid #98441F;
        border-left: 5px solid #98441F;
        border-bottom: 5px solid #311300;
        border-right: 5px solid #311300;
      }

      &.detail {
        img {
          margin-left: 8px;
        }

        border: none;
      }

      &.lounge {
        background: linear-gradient(40deg, #c0a417 0%, #c0a417 39%, #e2c743 51%, #c0a417 64%, #c0a417 100%);
        border-top: 4px solid #f4d046;
        border-left: 4px solid #f4d046;
        border-bottom: 4px solid #776a2c;
        border-right: 4px solid #776a2c;

        &.in-modal {
          border-width: 5px;
        }
      }

      &:disabled, &.disabled {
        border-top: none!important;
        border-right: none!important;
        border-bottom: none!important;
        border-left: none!important;
      }

      &.using {
        background: #6fb038!important;
        border: none!important;

        .badge {
          color: #6fb038;
        }

        .date {
          display: flex;
          flex-direction: column;
          align-items: center;

          span {
            font-size: 20px;
          }

          .caption {
            font-size: 12px
          }
        }
      }
    }
  }
}

div[class^="card-container free-pass-list-"] {
  background: none;
  box-shadow: none;

  .expire-at {
    display: flex;
    justify-content: center;
    align-items: center;
    width: fit-content;
    position: absolute;
    bottom: 34%;
    left: 0;
    right: 0;
    margin: auto;
    color: #ffffff;
    font-size: 12px;
    padding: 12px 0;

    & > * + * {
      margin-left: 6px;
    }

    div {
      display: flex;

      & > * + * {
        margin-left: 6px;
      }

      span {
        flex-shrink: 0;
      }
    }

    &.warning {
      background: url('~@/assets/img/coupon-with-cart/free-pass-expire-at-background.svg') no-repeat center;
      background-size: contain;
      font-weight: bold;
      padding: 0;

      div {
        display: flex;
        align-items: center;
        margin: 10px 20px;

        & > * + * {
          margin-left: 6px;
        }

        img {
          width: 16px;
          background: #fff;
          border-radius: 16px;
        }

        span {
          flex-shrink: 0;
        }
      }
    }
  }

  &.free-pass-list-1 {
    .expire-at {
      &.warning {
        color: #6a6a6a;
      }
    }
  }

  &.free-pass-list-2 {
    .expire-at {
      &.warning {
        color: #9f8710;
      }
    }
  }

  &.free-pass-list-3 {
    .expire-at {
      &.warning {
        color: #57778e;
      }
    }
  }

  &.free-pass-list-4 {
    .expire-at {
      &.warning {
        background: url('~@/assets/img/coupon-with-cart/free-pass-expire-at-background-gold.svg') no-repeat center;
        background-size: contain;
        color: #000000;
      }
    }
  }

  .button-container {
    width: 90%;
    position: absolute;
    bottom: 8.5%;
    left: 0;
    right: 0;
    margin: auto;

    &.in-list {
      &::before {
        background-image: none;
      }
      background: none;

      button {
        font-size: unquote("min(3.5vw, 14px)");
        flex-shrink: 0;
      }
    }
  }
}

div[class^="card-container free-pass-modal-"] {
  .card-header {
    .left {
      .card-type {
        display: none;
      }
    }
  }
}

button[class^="free-pass-list-"], button[class^="free-pass-modal-"] {
  .badge {
    background: #958848;
    color: #ffffff;
  }
}

button[class^="free-pass-list-"] {
  &.free-pass-list-4 {
    background: linear-gradient(40deg, #c0a417 0%, #c0a417 39%, #e2c743 51%, #c0a417 64%, #c0a417 100%)!important;
    border-top: 4px solid #f4d046!important;
    border-left: 4px solid #f4d046!important;
    border-bottom: 4px solid #776a2c!important;
    border-right: 4px solid #776a2c!important;
  }
}

button[class^="free-pass-modal-"] {
  color: #ffffff;

  &.free-pass-modal-1 {
    background: linear-gradient(40deg, #9f9f9f 0%, #9f9f9f 39%, #c5c5c5 51%, #9f9f9f 64%, #9f9f9f 100%)!important;
    border-top: 5px solid #cccccc!important;
    border-left: 5px solid #cccccc!important;
    border-bottom: 5px solid #6a6a6a!important;
    border-right: 5px solid #6a6a6a!important;

    &.detail {
      border: none!important;
    }
  }

  &.free-pass-modal-2 {
    background: linear-gradient(40deg, #c0a417 0%, #c0a417 39%, #e2c743 51%, #c0a417 64%, #c0a417 100%)!important;
    border-top: 5px solid #f4d046!important;
    border-left: 5px solid #f4d046!important;
    border-bottom: 5px solid #776a2c!important;
    border-right: 5px solid #776a2c!important;

    &.detail {
      border: none!important;
    }
  }

  &.free-pass-modal-3 {
    background: linear-gradient(40deg, #7dabcd 0%, #7dabcd 39%, #aecce3 51%, #7dabcd 64%, #7dabcd 100%)!important;
    border-top: 5px solid #bccfdd!important;
    border-left: 5px solid #bccfdd!important;
    border-bottom: 5px solid #527188!important;
    border-right: 5px solid #527188!important;

    &.detail {
      border: none!important;
    }
  }

  &.free-pass-modal-4 {
    background: linear-gradient(40deg, #000000 0%, #111111 39%, #555555 51%, #111111 64%, #000000 100%)!important;
    border-top: 5px solid #9f9f9f!important;
    border-left: 5px solid #9f9f9f!important;
    border-bottom: 5px solid #484848!important;
    border-right: 5px solid #484848!important;

    &.detail {
      border: none!important;
    }
  }
}
</style>
